import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MunicipalityOnboardingComponent } from './municipality-onboarding.component';
import { MunicipalityListTableComponent } from './municipality-list-table/municipality-list-table.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from './custom-mat-paginator-int';
import { MunicipalityOnboardingModalComponent } from './municipality-onboarding-modal/municipality-onboarding-modal.component';
import { MunicipalityOnboardingResultModalComponent } from './municipality-onboarding-result-modal/municipality-onboarding-result-modal.component';
import { MunicipalityOnboardingConfirmCancelModalComponent } from './municipality-onboarding-confirm-cancel-modal/municipality-onboarding-confirm-cancel-modal.component';

@NgModule({
  declarations: [
    MunicipalityOnboardingComponent,
    MunicipalityListTableComponent,
    MunicipalityOnboardingModalComponent,
    MunicipalityOnboardingResultModalComponent,
    MunicipalityOnboardingConfirmCancelModalComponent,
  ],
  imports: [CommonModule, SharedModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: CustomMatPaginatorIntl,
    },
  ],
})
export class MunicipalityOnboardingModule {}
